import React from 'react';
const globalLoaderDebounceTimeout = 50;
let initialGlobalLoaderVisible = true;
let visibleGlobalLoaderCounter = 0;
let hideGlobalLoaderTimeoutHandle = undefined;
export function hideInitialGlobalLoader() {
    if (initialGlobalLoaderVisible) {
        initialGlobalLoaderVisible = false;
        hideGlobalLoaderTimeoutHandle = window.setTimeout(() => {
            var _a;
            if (visibleGlobalLoaderCounter === 0) {
                hideGlobalLoader();
                (_a = document.getElementById('app-global-loader-initial-message')) === null || _a === void 0 ? void 0 : _a.remove();
            }
        }, globalLoaderDebounceTimeout);
    }
}
function showGlobalLoader() {
    var _a;
    if (hideGlobalLoaderTimeoutHandle != null) {
        window.clearTimeout(hideGlobalLoaderTimeoutHandle);
        hideGlobalLoaderTimeoutHandle = undefined;
    }
    (_a = document.getElementById('app-global-loader-initial-message')) === null || _a === void 0 ? void 0 : _a.remove();
    const container = document.getElementById('app-container');
    const loader = document.getElementById('app-global-loader');
    if (container && loader) {
        container.style.display = 'none';
        loader.style.display = 'flex';
    }
}
function hideGlobalLoader() {
    const container = document.getElementById('app-container');
    const loader = document.getElementById('app-global-loader');
    if (container && loader) {
        container.style.display = 'block';
        loader.style.display = 'none';
    }
}
function hideGlobalLoaderWithDebounce(messageItem) {
    hideGlobalLoaderTimeoutHandle = window.setTimeout(() => {
        hideGlobalLoader();
        hideGlobalLoaderTimeoutHandle = undefined;
    }, globalLoaderDebounceTimeout);
    messageItem === null || messageItem === void 0 ? void 0 : messageItem.remove();
}
/**
 * React component to control visibility of a global loader and display contextual messages.
 * Manages loader state through mounting/unmounting and DOM updates.
 *
 * @param {GlobalLoaderProps} props - Props to configure the global loader.
 * @param {string} [props.message] - Optional message to display in the loader UI.
 *
 * @returns {null} This component does not render any React element to the DOM.
 */
export const GlobalLoader = (props) => {
    const id = React.useId();
    React.useEffect(() => {
        var _a;
        const message = document.getElementById('app-global-loader-message');
        let messageItem = document.getElementById(id);
        if (message) {
            if (!messageItem) {
                messageItem = document.createElement('div');
                messageItem.id = id;
                message.appendChild(messageItem);
            }
            messageItem.innerText = (_a = props.message) !== null && _a !== void 0 ? _a : '';
        }
        if (visibleGlobalLoaderCounter === 0) {
            showGlobalLoader();
        }
        ++visibleGlobalLoaderCounter;
        return () => {
            --visibleGlobalLoaderCounter;
            if (visibleGlobalLoaderCounter === 0) {
                hideGlobalLoaderWithDebounce(messageItem);
            }
            else {
                messageItem === null || messageItem === void 0 ? void 0 : messageItem.remove();
            }
        };
    }, [props.message, id]);
    return null;
};
